// extracted by mini-css-extract-plugin
export default {"Truncate":"Truncate_Truncate__sNbHm"};